export default __webpack_public_path__ + "static/media/chat_logo_keto.723f8900.svg";